<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-section">
          <h3 class="footer-title">智慧园区</h3>
          <p class="footer-desc">让园区管理更智能、更便捷</p>
        </div>
        
        <div class="footer-section">
          <h3 class="footer-title">快速链接</h3>
          <div class="footer-links">
            <a @click="handleLinkClick('/')">首页</a>
            <a @click="handleLinkClick('/service')">服务中心</a>
            <a @click="handleLinkClick('/park/application')">入驻申请</a>
            <a @click="handleLinkClick('/service/announcement')">通知公告</a>
          </div>
        </div>
        
        <div class="footer-section">
          <h3 class="footer-title">联系我们</h3>
          <!-- <p class="contact-item">
            <el-icon><Phone /></el-icon>
            <span>400-888-9999</span>
          </p>
          <p class="contact-item">
            <el-icon><Message /></el-icon>
            <span>contact@smartpark.com</span>
          </p>
          <p class="contact-item">
            <el-icon><Location /></el-icon>
            <span>北京市海淀区中关村大街1号</span>
          </p> -->
        </div>
      </div>
      
      <div class="footer-bottom">
        <p class="copyright">© {{ currentYear }} 智慧园区综合服务平台 版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Phone, Message, Location } from '@element-plus/icons-vue'

const router = useRouter()

// 获取当前年份
const currentYear = computed(() => new Date().getFullYear())

// 处理链接点击
const handleLinkClick = (path) => {
  router.push(path)
}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #f0f2f7;
  padding: 40px 0 20px;
  margin-top: 40px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
}

.footer-section {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
  padding-right: 20px;
  
  &:last-child {
    padding-right: 0;
  }
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 15px;
}

.footer-desc {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.footer-links {
  display: flex;
  flex-direction: column;
  
  a {
    color: #666;
    text-decoration: none;
    margin-bottom: 10px;
    cursor: pointer;
    
    &:hover {
      color: var(--el-color-primary);
    }
  }
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #666;
  
  .el-icon {
    margin-right: 8px;
    color: #999;
  }
}

.footer-bottom {
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  text-align: center;
}

.copyright {
  color: #999;
  font-size: 14px;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .app-footer {
    padding: 30px 0 15px;
  }
  
  .footer-top {
    flex-direction: column;
  }
  
  .footer-section {
    margin-bottom: 25px;
    padding-right: 0;
  }
}
</style> 